import {AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY, contentConstraintHasDDBAnnotation} from "../../../utils/annotations";
import { getStringFromArtefactTriplet } from "../../../utils/sdmxJson";
import moment from "moment";
import {getAutoAnnotations, getFilteredAnnotations} from "../../../utils/artefacts";
import {getFilterObjFromStr, getServerQueryObj} from "../../../utils/filter";

export function getLinkedDataflowSource(node, dataflow, dataflowTriplet) {

  const linkedInfo = {
    endpointId: null,
    dfId: null
  }

  const linkedAnnotationType = (node.annotations[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY].type || "").toLowerCase();
  let linkedDataflowAnnotation = null;
  if (dataflow) {
    linkedDataflowAnnotation = (dataflow.annotations || []).find((ann) => (ann && (ann.type || "").toLowerCase()) === linkedAnnotationType);
    if (!linkedDataflowAnnotation) {
      linkedDataflowAnnotation = (dataflow.autoAnnotations || []).find((ann) => (ann && (ann.type || "").toLowerCase()) === linkedAnnotationType);
    }
  }

  const sourceEndpointId = linkedDataflowAnnotation
    ? (linkedDataflowAnnotation.title || "").length > 0 ? linkedDataflowAnnotation.title : null
    : null;

  const sourceDataflowId = linkedDataflowAnnotation
    ? linkedDataflowAnnotation.text
      ? linkedDataflowAnnotation.text["en"]
      : dataflowTriplet ? getStringFromArtefactTriplet(dataflowTriplet) : null
    : null;

    linkedInfo.endpointId = sourceEndpointId;
    linkedInfo.dfId = sourceDataflowId;

  return linkedInfo;

}


export function setLinkedDataflowAnnotationText(linkedDataflowNodeAnnotationType, dataflow, dataflowTriplet) {

  let linkedDataflowAnnotation = (dataflow.autoAnnotations || [])
    .find((ann) => ( ann && (ann.type || "").toLowerCase() === linkedDataflowNodeAnnotationType.toLowerCase()));

  const text = dataflowTriplet
    ? {
        "en" : getStringFromArtefactTriplet(dataflowTriplet)
      }
    : null;
  if (linkedDataflowAnnotation) {
    linkedDataflowAnnotation.type = linkedDataflowNodeAnnotationType;
    linkedDataflowAnnotation.id = linkedDataflowNodeAnnotationType;
    linkedDataflowAnnotation.text = text;
  } else {
    linkedDataflowAnnotation = {
      type: linkedDataflowNodeAnnotationType,
      id: linkedDataflowNodeAnnotationType,
      text: text,
    };
  }

  const autoAnnotations = (dataflow.autoAnnotations || [])
      .filter((ann) => ( ann && (ann.type || "").toLowerCase() !== linkedDataflowNodeAnnotationType.toLowerCase()));

  autoAnnotations.push(linkedDataflowAnnotation);

  return autoAnnotations;
}

export function setLinkedDataflowAnnotationTitle(linkedDataflowNodeAnnotationType, dataflow, endpointId) {

  let linkedDataflowAnnotation = (dataflow.autoAnnotations || [])
    .find((ann) => ( ann && (ann.type || "").toLowerCase() === linkedDataflowNodeAnnotationType.toLowerCase()));
      if (linkedDataflowAnnotation) {
        linkedDataflowAnnotation.type = linkedDataflowNodeAnnotationType;
        linkedDataflowAnnotation.id = linkedDataflowNodeAnnotationType;
        linkedDataflowAnnotation.title = endpointId;
        linkedDataflowAnnotation.text = null;
      }
      else {
        linkedDataflowAnnotation =
        {
          type: linkedDataflowNodeAnnotationType,
          id: linkedDataflowNodeAnnotationType,
          title: endpointId,
          text: null
        }
      }

    const autoAnnotations = (dataflow.autoAnnotations || [])
      .filter((ann) => (ann && (ann.type || "").toLowerCase() !== linkedDataflowNodeAnnotationType));

    autoAnnotations.push(linkedDataflowAnnotation);

    return autoAnnotations;
}

export const prepareDataflows = (dataflows, annotationsConfig, customIsAutoAnnotation) => dataflows.map(d => prepareDataflow(d, annotationsConfig, customIsAutoAnnotation))

const prepareDataflow = (dataflow, annotationsConfig, customIsAutoAnnotation) => ({
  ...dataflow,
  validFrom: (dataflow.validFrom && moment(dataflow.validFrom).unix() > 0)
      ? moment(dataflow.validFrom)
      : undefined,
  validTo: (dataflow.validTo && moment(dataflow.validTo).unix() > 0)
      ? moment(dataflow.validTo)
      : undefined,
  reportingBegin: (dataflow.reportingBegin && moment(dataflow.reportingBegin).unix() > 0)
      ? moment(dataflow.reportingBegin)
      : undefined,
  reportingEnd: (dataflow.reportingEnd && moment(dataflow.reportingEnd).unix() > 0)
      ? moment(dataflow.reportingEnd)
      : undefined,
  publicationYear: (dataflow.publicationYear && !isNaN(dataflow.publicationYear)) ? Number(dataflow.publicationYear) : undefined,
  annotations: dataflow.annotations
      ? getFilteredAnnotations(dataflow.annotations, annotationsConfig, customIsAutoAnnotation).map(annot => ({
        ...annot,
        text: annot.texts, // fix after sdmx-source update 1.17
        texts: undefined // fix after sdmx-source update 1.17
      }))
      : undefined,
  autoAnnotations: dataflow.annotations
      ? getAutoAnnotations(dataflow.annotations, annotationsConfig, customIsAutoAnnotation).map(annot => ({
        ...annot,
        text: annot.texts, // fix after sdmx-source update 1.17
        texts: undefined // fix after sdmx-source update 1.17
      }))
      : undefined,
});



export const getDataflowDDBContentConstraint = (dataflowProductionModalDataflow, dataflowProductionModalContentConstraints,
  annotationsConfig) => {
  const dataflowDDBContentConstraints =
    dataflowProductionModalDataflow !== null
    ? (dataflowProductionModalContentConstraints || []).filter(cc =>
        contentConstraintHasDDBAnnotation(annotationsConfig, cc))
    : [];

  return dataflowDDBContentConstraints.length ? dataflowDDBContentConstraints[0] : null;

}

export const getSimplifiedFilterObj = (filterStr = "") => getServerQueryObj(null,
        getFilterObjFromStr(
            filterStr
        ),
    undefined,
    undefined,
    undefined,
    undefined,
    null,
    null
);
